import React from "react";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import NoticeMeIcon from "@mui/icons-material/FiberNew";

const NavigationCard = ({
  title,
  description,
  url,
  showNoticeMeIcon = false,
  campaign,
}) => {
  const isExternalLink =
    url.startsWith("http://") || url.startsWith("https://");

  var campaignUrl = "";
  if (showNoticeMeIcon && campaign) {
    campaignUrl = new URL(url);
    campaignUrl.searchParams.set("utm_source", "advancement-solutions");
    campaignUrl.searchParams.set("utm_medium", "webapp");
    campaignUrl.searchParams.set("utm_campaign", campaign);
  }

  return (
    <Tooltip title={description}>
      <Card
        sx={{
          margin: 1,
          width: 195,
          position: "relative",
        }}
      >
        {isExternalLink ? (
          <CardActionArea
            component="a"
            href={showNoticeMeIcon && campaign ? campaignUrl : url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CardContent>
              <Typography
                align="center"
                gutterBottom
                variant="subtitle1"
                component="h1"
              >
                {title}
              </Typography>
              {showNoticeMeIcon && (
                <NoticeMeIcon
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    fontSize: "2rem",
                    opacity: 1,
                    color: "secondary.main",
                  }}
                />
              )}
            </CardContent>
          </CardActionArea>
        ) : (
          <CardActionArea component={Link} to={url}>
            <CardContent>
              <Typography
                align="center"
                gutterBottom
                variant="subtitle1"
                component="h1"
              >
                {title}
              </Typography>
            </CardContent>
          </CardActionArea>
        )}
      </Card>
    </Tooltip>
  );
};

export default NavigationCard;
